export default __webpack_public_path__ + "static/media/d21.f6c15fe7.png";